// src/utils/findCurrentPage.js
import { navConfig } from './navConfig';

export function findCurrentPage(pathname) {
  let activeRole = null;
  let activePage = null;

  for (const role of navConfig) {
    if (pathname.startsWith(`/${role.key}`)) {
      activeRole = role;

      // Ищем страницу во всех секциях роли
      for (const section of role.sections || []) {
        const found = section.items.find(item => pathname.startsWith(item.to));
        if (found) {
          activePage = found;
          break;
        }
      }

      break;
    }
  }

  return { activeRole, activePage };
}
